import React from 'react'
import { connect } from 'react-redux'
import { getFormValue, hasChangedValues } from '../../public/utility/formValues'

class CurrencyDiv extends React.Component {
	state = {}
	componentDidMount = () => {
		const { id } = this.props
		Tyan.doPostEvent({
			event: 'GetCurrency',
			data: { id },
			onEnd: ({ errorMessage, initValues基本信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				this.setState({ initValues基本信息 })
			}
		})
	}

	handlerSave = () => {
		const { changedValues基本信息, } = this.state
		const { onSave, onClose, id } = this.props
		Tyan.doPostEvent({
			event: 'SaveCurrency',
			data: { id, changedValues基本信息 },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				Ext.toast('保存成功')
				onClose && onClose()
				onSave && onSave()
			}
		})
	}

	handlerDelete = () => {
		const { onSave, onClose, id } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteCurrency',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
						return
					}
					Ext.toast('删除成功')
					onClose && onClose()
					onSave && onSave()
				}
			}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		return !Tyan.checkForm.checkLimited(this)
	}

	fieldset基本信息 = () => {
		return [
			{ _text: '币别', minWidth: '90%', required: true },
			{ _text: '缩写', minWidth: '90%', required: true },
			{ _text: '币别符号', minWidth: '90%', },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, id } = this.props
		const { initValues基本信息 } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const canSave = this.canSave()
		const bChanged = this.bChanged()
		return <Body data={this} maxWidth="700" minWidth="700"
			controls={
				[
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
					{ _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
				]}
		/>
	}
}

export default connect()(CurrencyDiv)